import { MDText } from 'i18n-react';

import { APP_URL } from 'Utilities/urls';

import LocalTexts from '../../texts.json';

type toolsSectionThemes = 'light-yellow' | 'white' | 'yellow';

const LocalT = new MDText(LocalTexts);

const t = (key: string) => LocalT.translate(key) as string;

const CAR_VALUE_TRACKER_URL = '/car-value-tracker';

const TOOLS_CARD_TYPES = {
  APP: 'app',
  CVT: 'cvt',
};

export const toolsSectionContent = [
  {
    label: t('tools.app.label'),
    link: {
      ctaLabel: t('tools.app.cta'),
      openInNewTab: true,
      route: APP_URL,
    },
    theme: 'yellow' as toolsSectionThemes,
    title: t('tools.app.title'),
    type: TOOLS_CARD_TYPES.APP,
  },
  {
    label: t('tools.cvt.label'),
    link: {
      ctaLabel: t('tools.cvt.cta'),
      route: CAR_VALUE_TRACKER_URL,
    },
    theme: 'light-yellow' as toolsSectionThemes,
    title: t('tools.cvt.title'),
    type: TOOLS_CARD_TYPES.CVT,
  },
];
